import React, { useState } from 'react';
import cx from 'classnames';
import { Card } from './Card';
export const CardDecision = ({ question, className = '', choices = [] }) => {
    const [selected, setSelected] = useState(null);
    return (React.createElement(Card, { className: cx('card-decision', className) },
        React.createElement("div", { className: "card-decision_header" },
            React.createElement("h6", null, question)),
        React.createElement("div", { className: "card-decision_choises" }, choices.map(({ label, onSelect }, index) => {
            return (React.createElement("div", { key: label, className: "card-decision_choise" },
                React.createElement("a", { className: cx('', {
                        selected: index === selected,
                    }), onClick: () => {
                        if (onSelect) {
                            onSelect(label);
                        }
                        setSelected(index);
                    } }, label)));
        }))));
};
//# sourceMappingURL=CardDecision.js.map